module.exports = __webpack_public_path__ + "assets/img/page5-nav-item-11-c98b3066.png";